<template>
    <div class="sensor_main" :class="{'cn':version == '1'}">
        <div class="sensor_left">
            <!-- <side-bar></side-bar> -->
        </div>
        <div class="sensor_right">
            <div class="sensor_right_top">
                <div class="right_top_l">
                    <el-select v-model="buildId">
                        <el-option
                            v-for="item in buildNav"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                        </el-option>
                    </el-select>
                    <el-input :placeholder="$t('App.lights.text24')" v-model="keywords" @keyup.native="getSensorListKeyUp($event)" class="input-with-select">
                        <i slot="suffix" class="el-input__icon el-icon-search" @click="getSensorList()"></i>
                    </el-input>
                </div>
            </div>
            <div class="sensor_right_main">
                <div class="main_top">
                    <div class="main_top_l">
                        <div class="div1"><span>{{$t('App.sideBar.text15')}}</span></div>
                        <div class="div2">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">{{$t('App.lights.text10')}}</el-checkbox>
                            <div class="btn" @click="postDelLight(checkList,'batch')">
                                <i class="iconfont icon-delete"></i>
                                <span>{{$t('App.lights.text1')}}</span>
                            </div>
                            <div class="btn" @click="postReData(checkList)" v-loading="reDataIndex>0">
                                <i class="iconfont icon-refresh"></i>
                                <span>{{$t('App.lights.text4')}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="main_top_r">
                        <div class="btn" @click="addSensorFun()"><img :src="img_lights_2"><span>{{$t('App.lights.text5')}}</span></div>
                    </div>
                </div>
                <div class="main_cont">
                    <el-checkbox-group v-model="checkList" @change="handleCheckedCitiesChange">
                            <!-- element-loading-background="rgba(0, 0, 0, 0.5)" -->
                        <el-table
                            ref="sensorDataList"
                            v-loading="loading.sensorDataList"
                            height="100%"
                            :data="sensorDataList">
                            <el-table-column
                                :label="$t('App.lights.text33')"
                                :prop="'index'"
                                align="left"
                                header-align="center"
                                :width="6*remRatio">
                                <template slot-scope="scope">
                                    <el-checkbox :label="scope.row.id" :key="scope.row.id">{{scope.row.webIndex}}</el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text42')"
                                :prop="'name'"
                                align="left"
                                header-align="left"
                                :show-overflow-tooltip="true"
                                :min-width="6*remRatio">
                            </el-table-column>
                            <el-table-column
                                :label="$t('App.room.text43')"
                                :prop="'deviceId'"
                                align="center"
                                :show-overflow-tooltip="true"
                                :min-width="7*remRatio">
                            </el-table-column>
                            <el-table-column
                                v-for="(item) in sensorArr"
                                :key="'table_'+item.prop"
                                :prop="item.prop"
                                :label="item.label"
                                :align="item.align?item.align:'center'"
                                :width="item.width"
                                :show-overflow-tooltip="true"
                                :min-width="item.minWidth">
                                    <template slot-scope="scope">
                                        <div v-if="item.type != 1">{{scope.row[item.prop]?scope.row[item.prop]+(item.unit):' '}}</div>
                                        <div v-if="item.prop == 'pm10'">{{(scope.row[item.prop]&&scope.row[item.prop]!='-')?scope.row[item.prop]+(item.unit):'-'}}</div>
                                        <div v-if="item.prop == 'online'" class="online">
                                            <i v-if="scope.row.online=='0'" class="iconfont icon-disconnect" style="color:rgba(163,175,187,1);"></i>
                                            <i v-if="scope.row.online=='1'" class="iconfont icon-connectx" :style="{'color': version=='0'?'rgba(5, 207, 171, 1)':'#8266C7'}"></i>
                                        </div>
                                        <div v-if="item.prop == 'alarmStatus'" class="alarmStatus">
                                            <span :class="'text_'+scope.row[item.prop]" @click="linkToFun('/service',scope.row)">{{scope.row[item.prop]==0?'normal':scope.row.alarmInfo}}<i class="iconfont icon-weixiu1" v-if="scope.row[item.prop] == 1"></i>
                                            </span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                align="center"
                                :width="9*remRatio"
                                :label="$t('App.lights.text6')">
                                <template slot-scope="scope">
                                    <span class="btn" @click="editFun(scope.row)" :title="$t('App.lights.text7')">
                                        <i class="iconfont icon-bianji"></i>
                                    </span>
                                    <span class="btn" @click="dev_register(scope.row)" :title="$t('App.lights.text4')" v-loading="scope.row.senser_dev_register_asy">
                                        <i class="iconfont icon-refresh"></i>
                                    </span>
                                    <span class="btn" @click="historySee(scope.row)" :title="$t('App.lights.text8')">
                                        <i class="iconfont icon-history"></i>
                                    </span>
                                    <span class="btn" @click="postDelLight(scope.row)" :title="$t('App.lights.text1')">
                                        <i class="iconfont icon-delete"></i>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-checkbox-group>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-size="pageSize"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <div class="sensor_wrap scrollbar_style" v-show="sensorTkShowbg">
            <div class="sensor_wrap_bg" @click="sensorTkClose()"></div>
            <div class="sensor_box" :class="{'sensor_tk_show':sensorTkShow}">
                <div class="sensor_title">
                    <span class="span1">{{sensorTkTitle}}</span>
                    <span class="span2" @click="sensorTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="form">
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text42')}}</span>
                        <el-input v-model="sensorForm.name" placeholder="Please enter device name"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text57')}}</span>
                        <el-dropdown @command="commandModel" trigger="click" @visible-change="commandHide('dropdown_lights_model')">
                            <span class="span1">{{sensorFormModelName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_lights_model">
                                <el-dropdown-item v-for="item in modelNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==sensorForm.model}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text43')}}</span>
                        <el-input v-model="sensorForm.deviceId" placeholder="Please enter device id"></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room_light.text58')}}</span>
                        <el-input v-model="sensorForm.gatewayId" placeholder=""></el-input>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text29')}}</span>
                        <el-dropdown @command="commandFloor" trigger="click" @visible-change="commandHide('dropdown_sensor_floor')">
                            <span class="span1">{{sensorFormFloorName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_sensor_floor">
                                <el-dropdown-item v-for="item in floorNav" :command="item" :key="'floor'+item.id" :class="{'select':item.id==sensorForm.floorId}">{{item.name}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="form_item">
                        <span class="laber">{{$t('App.room.text30')}}</span>
                        <el-dropdown @command="commandRoom" trigger="click" @visible-change="commandHide('dropdown_sensor_room')">
                            <span class="span1">{{sensorFormRoomName}}<i class="el-icon-caret-bottom el-icon--right"></i></span>
                            <el-dropdown-menu slot="dropdown" class="scrollbar_style dropdown_sensor_room">
                                <el-dropdown-item v-for="item in roomNav" :command="item" :key="'room'+item.id"  :class="{'select':item.id==sensorForm.roomId}">{{item.number}}</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <div class="btn_box">
                    <div class="btn" @click="postSaveSensor()">{{$t('App.room.text35')}}</div>
                </div>
            </div>
        </div>
        <!-- 历史 -->
        <div class="history_warp scrollbar_style" v-show="historyShowbg">
            <div class="history_warp_bg" @click="historyClose()"></div>
            <div class="history_box" :class="{'history_show':historyShow}">
                <div class="history_top">
                    <span class="span1">{{$t('App.room_light.text8')}}</span>
                    <span class="span2" @click="historyClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="filter_box">
                    <el-select v-model="chartType" placeholder=" " @change="chartTypeChange(chartType)" v-if="networHistoryType == '1'">
                        <el-option
                          v-for="item in chartTypeArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="timeType2" placeholder=" " @change="timeType2Change(timeType2)">
                        <el-option
                          v-for="item in timeTypeArr"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="table_top_box">
                    <div class="box1">
                       <div class="btn" :class="{'select':networHistoryType == '1'}" @click="networHistoryTypeFun('1')">{{$t('App.lights.text15')}}</div>
                       <div class="btn" :class="{'select':networHistoryType == '2'}" @click="networHistoryTypeFun('2')">{{$t('App.lights.text16')}}</div>
                    </div>
                    <div class="download_btn" @click="sensorLogList(sensorId,timeType2,1)" v-loading="loading.sensorDataList2_csv">{{$t('App.lights.text17')}}</div>
                </div>
                <div class="echarts_warp scrollbar_style" v-if="networHistoryType == '1'">
                    <div class="echarts_box echarts_box1">
                        <div class="echarts_top">{{$t('App.sensor.text3')}}</div>
                        <div class="history_echarts_box1"></div>
                    </div>
                    <div class="echarts_box echarts_box2">
                        <div class="echarts_top">{{$t('App.sensor.text4')}}</div>
                        <div class="history_echarts_box2"></div>
                    </div>
                    <div class="echarts_box echarts_box3">
                        <div class="echarts_top">{{$t('App.sensor.text5')}}</div>
                        <div class="history_echarts_box3"></div>
                    </div>
                    <div class="echarts_box echarts_box4">
                        <div class="echarts_top">{{$t('App.sensor.text6')}}</div>
                        <div class="history_echarts_box4"></div>
                    </div>
                    <div class="echarts_box echarts_box5">
                        <div class="echarts_top">{{$t('App.sensor.text10')}}</div>
                        <div class="history_echarts_box5"></div>
                    </div>
                    <div class="echarts_box echarts_box6">
                        <div class="echarts_top">{{$t('App.sensor.text7')}}</div>
                        <div class="history_echarts_box6"></div>
                    </div>
                    <div class="echarts_box echarts_box7">
                        <div class="echarts_top">{{$t('App.sensor.text8')}}</div>
                        <div class="history_echarts_box7"></div>
                    </div>
                </div>
                <div class="table_box" v-if="networHistoryType == '2'">
                    <el-table
                        ref="sensorDataList2"
                        v-loading="loading.sensorDataList2"
                        element-loading-background="rgba(0, 0, 0, 0.5)"
                        height="100%"
                        :data="sensorDataList2">
                        <el-table-column
                            :label="$t('App.lights.text33')"
                            :prop="'webIndex'"
                            align="center"
                            header-align="center"
                            :width="6*remRatio">
                        </el-table-column>
                        <el-table-column
                            v-for="(item) in sensorArr2"
                            :key="'table_'+item.prop"
                            :prop="item.prop"
                            :label="item.label"
                            :align="item.align?item.align:'center'"
                            :width="item.width"
                            :show-overflow-tooltip="true"
                            :min-width="item.minWidth">
                            <template slot-scope="scope">
                                <span v-if="item.type != 1">{{scope.row[item.prop]?scope.row[item.prop]:0}}{{item.unit?item.unit:''}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination_box">
                        <el-pagination
                            @size-change="handleSizeChange2"
                            @current-change="handleCurrentChange2"
                            :current-page="currentPage2"
                            :page-size="pageSize2"
                            layout="prev, pager, next"
                            :total="total2">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
        <!-- 网关升级 -->
        <div class="gatewayUpdate_wrap scrollbar_style" v-show="gatewayUpdateTkShowbg">
            <div class="gatewayUpdate_wrap_bg" @click="gatewayUpdateTkClose()"></div>
            <div class="gatewayUpdate_box" :class="{'gateway_tk_show':gatewayUpdateTkShow}">
                <div class="gatewayUpdate_title">
                    <span class="span1">{{$t('App.lights.text20')}}</span>
                    <span class="span2" @click="gatewayUpdateTkClose()">{{$t('App.room.text28')}}</span>
                </div>
                <div class="box1">
                   <div><img src="../img/upgrade.png"></div>
                   <div><span>{{gatewayUpdateSoftware}}</span></div>
                </div>
                <p class="p1">{{$t('App.lights.text21')}}</p>
                <div class="btn_box">
                    <div class="btn" v-if="gatewayUpdateType == '1'" @click="gatewayUpdateFun()">{{'Download '+gatewayUpdateVersion}}</div>
                    <el-progress :stroke-width="null" :percentage="uploadGatewayVal" :text-inside="true" v-if="gatewayUpdateType == '2'" v-loading="gatewayUpdateType =='2'"></el-progress>
                    <div class="text" :class="gatewayUpdateStatus=='0'?'span1':'span2'" v-if="gatewayUpdateType == '3'" @click="gatewayUpdateFun()">
                        <span v-if="gatewayUpdateStatus == '0'" class="span1">{{$t('App.lights.text22')}}</span>
                        <span v-if="gatewayUpdateStatus == '1'" class="span2">{{$t('App.lights.text23')}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    // import sideBar from '../components/sideBar.vue'
    import { mapGetters } from 'vuex'
    import allUrl from '../api/allUrl.js'
    import base from '../api/base.js'
    export default {
        name:'sensor',
        data () {
            return{
                buildId:'',
                buildNav:[],
                keywords:'',
                floorNav:[],
                roomNav:[],

                checkAll:false,
                isIndeterminate:false,
                checkList:[],

                sensorId:'0',
                sensorArr:[],
                sensorDataList:[],
                sensorDataIdList:[],
                alertsArr:['normal','alerts'],
                onlineArr:['Off-line','On-line'],

                currentPage:1,
                pageSize:20,
                total:0,


                sensorTkShowbg:false,
                sensorTkShow:false,
                sensorForm:{
                    name:'',
                    deviceId:'',
                    floorId:'',
                    roomId:'',
                    model:'',
                    gatewayId:'',
                    // type:'0',
                },
                sensorFormFloorName:'',
                sensorFormRoomName:'',
                sensorTkTitle:'',
                modelNav:[],

                historyShowbg:false,
                historyShow:false,
                networHistoryType:'1',
                chartType:'0',
                chartTypeStr:'line',
                chartTypeArr:[{label:'Line',value:'0',str:'line'},{label:'Bar',value:'1',str:'bar'}],
                timeType1:'0',
                timeType2:'0',
                timeTypeStr:'Daily',
                timeTypeArr:[{label:'Daily',value:'0'},{label:'Weekly',value:'1'},{label:'Monthly',value:'2'},{label:'Yearly',value:'3'}],

                sensorDataList2:[],
                sensorArr2:[],

                currentPage2:1,
                pageSize2:20,
                total2:0,

                websocket:null,
                reDataIndex:0,

                loading:{
                    sensorDataList:false,
                    sensorDataList2:false,
                    sensorDataList2_csv:false,
                },
                clientid:null,
                updateNetworkClientid:null,
                
                gatewayUpdateTkShowbg:false,
                gatewayUpdateTkShow:false,
                uploadGatewayVal:0,
                gatewayUpdateType:'1',
                gatewayUpdateSoftware:'',
                gatewayUpdateVersion:'',
                gatewayUpdateStatus:'1',

                img_lights_2:'',

                updateRemRatioShakeProof:null,
            }
        },
        computed:{
            ...mapGetters({
                token:'token',
                client_key:'client_key',
                username:'username',
                version:'version',

                remRatio:'remRatio',
                updateRemRatio:'updateRemRatio',

                countryId:'countryId',
                provinceId:'provinceId',
                cityId:'cityId',
                hotelId:'hotelId',
                headerIdStr:'headerIdStr',
            }),
            sensorFormModelName(){
                let name = '';
                for(let d of this.modelNav){
                    if(d.id == this.sensorForm.model){
                        name = d.name
                    }
                }
                return name
            }
        },
        components:{
            // 'sideBar':sideBar
        },
        beforeDestroy(){
            if(this.websocket){
                this.websocket.close();
            }
        },
        mounted(){
            this.img_lights_2 = require('../img/room/map/lights_2.png');

            if(this.version == '1'){
                this.img_lights_2 = require('../img/room/map/lights_2_v1.png');
            }
            this.alertsArr = [this.$t('App.room_light.text59'),this.$t('App.room_light.text60')];
            this.onlineArr = [this.$t('App.room.text65'),this.$t('App.room.text66')];
            this.chartTypeArr = [{label:this.$t('App.room_light.text61'),value:'0',str:'line'},{label:this.$t('App.room_light.text62'),value:'1',str:'bar'}];

            this.timeTypeStr = this.$t('App.room_light.text63');
            this.timeTypeArr = [{label:this.$t('App.room_light.text63'),value:'0'},{label:this.$t('App.room_light.text64'),value:'1'},{label:this.$t('App.room_light.text65'),value:'2'},{label:this.$t('App.room_light.text66'),value:'3'}];

            this.$store.commit('SIDEBARSHOW',{
                sideBarShow:true,
            })
            for(let i = 1;i<6;i++){
                let val = i<10?'0'+i:i;
                let id = -1 + i;
                this.$set(this.modelNav,this.modelNav.length,{id:id,name:'IH-SR'+val})
            }
            this.sensorArr = [
                {prop:'floor',label:this.$t('App.room.text29'),minWidth:5*this.remRatio,unit:''},
                {prop:'roomNumber',label:this.$t('App.room.text30'),minWidth:5*this.remRatio,unit:''},
                {prop:'temperature',label:this.$t('App.dashboard.text11'),minWidth:7.8*this.remRatio,unit:'℃'},
                {prop:'humidity',label:this.$t('App.dashboard.text12'),minWidth:5.8*this.remRatio,unit:'%RH'},
                {prop:'co2',label:'CO₂',minWidth:5*this.remRatio,unit:'ppm'},
                {prop:'pm25',label:'PM2.5',minWidth:5*this.remRatio,unit:'ug/m³'},
                {prop:'pm10',label:'PM10',minWidth:5*this.remRatio,unit:'ug/m³',type:1},
                {prop:'voc',label:'TVOC',minWidth:5*this.remRatio,unit:'ppb'},
                {prop:'formaldehyde',label:this.$t('App.dashboard.text13'),minWidth:5*this.remRatio,unit:'ppb'},
                {prop:'online',label:this.$t('App.sensor.text9'),minWidth:7.5*this.remRatio,type:1,unit:''},
                {prop:'alarmStatus',label:this.$t('App.lights.text31'),minWidth:10*this.remRatio,type:1,unit:''},
                {prop:'updateTime',label:this.$t('App.lights.text32'),width:10.5*this.remRatio,unit:''},
            ];
            this.sensorArr2 = [
                {prop:'temperature',label:this.$t('App.dashboard.text11'),minWidth:7.5*this.remRatio,unit:'℃'},
                {prop:'humidity',label:this.$t('App.dashboard.text11'),minWidth:6*this.remRatio,unit:'%RH'},
                {prop:'CO2',label:'CO₂',minWidth:5*this.remRatio,unit:'ppm'},
                {prop:'PM25',label:'PM2.5',minWidth:5*this.remRatio,unit:'ug/m³'},
                {prop:'PM10',label:'PM10',minWidth:5*this.remRatio,unit:'ug/m³',type:1},
                {prop:'VOC',label:'TVOC',minWidth:5*this.remRatio,unit:'ppb'},
                {prop:'formaldehyde',label:this.$t('App.dashboard.text13'),minWidth:5*this.remRatio,unit:'ppb'},
                {prop:'updateTime',label:this.$t('App.lights.text32'),width:10.5*this.remRatio,unit:''},
            ];
            this.getBuildNav(()=>{
                if(this.buildNav.length > 0){
                    this.buildId = this.buildNav[0].id;
                }else{
                    this.buildId = '';
                }
                this.getSensorList();
            });
            base.websocket_close(allUrl.websocket.ws,websocket=>{
                // console.log(websocket)
                this.websocket = websocket;
                this.websocket.send('{"type":"cmd"}');
                websocket.onmessage = event => {

                    let data = JSON.parse(event.data)
                    if(data.code == '0000'){
                        if(data.data.status == '1'){
                            this.clientid = data.data.clientid
                        }
                        if(data.data.status == '2'){
                            this.$notify({
                                title: data.msg,
                                message: this.$t('App.message.text20')+data.data.name,
                                type: 'success'
                            });
                            if(data.data.type == 'ref_data'){
                                this.reDataIndex--;
                                if(this.reDataIndex<0){
                                    this.reDataIndex = 0;
                                }
                                this.getSensorList();
                            }
                            if(data.data.type == 'senser_dev_register_asy'){
                                for(let d of this.sensorDataList){
                                    if(d.id == data.data.sensorId){
                                        d.senser_dev_register_asy = false;
                                    }
                                }
                            }

                        }
                    }else{
                        this.$alert(data.msg, this.$t('App.message.text1'), {
                            confirmButtonText: this.$t('App.message.text2'),
                        });
                        if(data.data.type == 'senser_dev_register_asy'){
                            for(let d of this.sensorDataList){
                                if(d.id == data.data.sensorId){
                                    d.senser_dev_register_asy = false;
                                }
                            }
                        }
                    }
                }
            })
        },
        methods:{
            linkToFun(val,data){
                if(val == '/service'){
                    if(data.alarmStatus == 1){
                        let disConnectTime = '';
                        if(data.disConnectTime){
                           disConnectTime = new Date(data.disConnectTime).format("YYYY-mm-dd");
                        }
                        this.$router.push({path:val+'?floorId='+data.floorId+'&roomId='+data.roomId+'&deviceType=2'+'&daysDate='+disConnectTime});
                    }
                }
            },
            gatewayUpdateFun(){
                if(this.gatewayUpdateStatus == '1'||this.gatewayUpdateType == '2'){
                    base.websocket(allUrl.websocket.ws,websocket=>{
                        this.websocket1 = websocket;
                        websocket.send('{"type":"updateNetwork","gatewayId":"'+this.gatewayAddress+'"}');
                        websocket.onmessage = event => {
                            // console.log(JSON.parse(event.data));
                            let data = JSON.parse(event.data)
                            if(data.code == '0000'){
                                if(data.data.status == '1'){
                                    this.updateNetworkClientid = data.data.clientid
                                    base.ajax_postWs(
                                        allUrl.gateway.updateFire,
                                        {
                                            username:this.username,
                                            client_key:this.client_key,
                                            token:this.token,
                                            id:this.gatewayId,
                                            clientId:this.updateNetworkClientid,
                                        },
                                        this
                                    )
                                    this.uploadGatewayVal = 0;
                                    this.gatewayUpdateType = '2';
                                }
                                if(data.data.status == '2'){
                                    if(data.data.type == 'updateNetwork'){
                                        this.uploadGatewayVal = data.data.step;
                                        if(this.uploadGatewayVal>=100){
                                            this.gatewayUpdateType = '3';
                                            this.gatewayUpdateStatus = '1';
                                        }
                                    }
                                }
                            }else{
                                this.$alert(data.msg, this.$t('App.message.text1'), {
                                    confirmButtonText: this.$t('App.message.text2'),
                                });
                                if(data.data.status == '2'){
                                    if(data.data.type == 'updateNetwork'){
                                        this.uploadGatewayVal = 0;
                                        this.gatewayUpdateType = '3';
                                        this.gatewayUpdateStatus = '0';
                                    }
                                }
                            }
                        }
                    })
                }
            },
            upgradeFun(obj){
                if(obj.online == 0){
                    this.$notify({
                        message: this.$t('App.message.text9'),
                        type: 'warning'
                    });
                    return
                }
                // this.gatewayUpdateTkShowbg = true;
                // this.gatewayUpdateSoftware = obj.software;
                // this.gatewayId = obj.id;
                // this.gatewayAddress = obj.gatewayId;

                // this.gatewayUpdateType = '1';
                // this.gatewayUpdateStatus = '1';
                // base.ajax_post(
                //     allUrl.gateway.checkUpdate,
                //     {
                //         username:this.username,
                //         client_key:this.client_key,
                //         token:this.token,
                //         id:obj.id,
                //     },
                //     {},
                //     data=>{
                //         if(data.data.status == '1'){
                //             this.gatewayUpdateTkShow = true;
                //             this.gatewayUpdateVersion = data.data.version
                //         }else{
                //             this.gatewayUpdateTkShowbg = false;
                //             this.$notify({
                //                 message: data.data.version+'is the latest version',
                //                 type: 'success'
                //             });
                //         }
                //     },
                //     this,()=>{
                //         this.gatewayUpdateTkShowbg = false;
                //     }
                // )
            },
            gatewayUpdateTkClose(){
                let this_ = this;
                this.gatewayUpdateTkShow = false;
                setTimeout(function(){
                    this_.gatewayUpdateTkShowbg = false;
                },400)
            },

            chartTypeChange(){
                for(let d of this.chartTypeArr){
                    if(d.value == this.chartType){
                        this.chartTypeStr = d.str
                    }
                }
                this.getSensorHistory(this.timeType2,data=>{
                    this.echartsFun({dataList:data.data.temperature,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box1','℃');
                    this.echartsFun({dataList:data.data.humidity,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box2','RH%');
                    this.echartsFun({dataList:data.data.CO2,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3','ppm');
                    this.echartsFun({dataList:data.data.PM25,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box4','ug/m³');
                    this.echartsFun({dataList:data.data.PM10,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box5','ug/m³');
                    this.echartsFun({dataList:data.data.formaldehyde,timeList:data.data.updateTime},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box6','ppb');
                    this.echartsFun({dataList:data.data.VOC,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box7','ppb');
                })
            },
            timeType2Change(){

                if(this.networHistoryType == '1'){
                    this.getSensorHistory(this.timeType2,data=>{
                        this.echartsFun({dataList:data.data.temperature,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box1','℃');
                        this.echartsFun({dataList:data.data.humidity,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box2','RH%');
                        this.echartsFun({dataList:data.data.CO2,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3','ppm');
                        this.echartsFun({dataList:data.data.PM25,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box4','ug/m³');
                        this.echartsFun({dataList:data.data.PM10,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box5','ug/m³');
                        this.echartsFun({dataList:data.data.formaldehyde,timeList:data.data.updateTime},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box6','ppb');
                        this.echartsFun({dataList:data.data.VOC,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box7','ppb');
                    })
                }
                else{
                    this.sensorLogList(this.sensorId,this.timeType2,0)
                }
            },
            networHistoryTypeFun(val){
                this.networHistoryType = val;

                if(this.networHistoryType == '1'){
                    this.getSensorHistory(this.timeType2,data=>{
                        this.echartsFun({dataList:data.data.temperature,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box1','℃');
                        this.echartsFun({dataList:data.data.humidity,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box2','RH%');
                        this.echartsFun({dataList:data.data.CO2,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3','ppm');
                        this.echartsFun({dataList:data.data.PM25,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box4','ug/m³');
                        this.echartsFun({dataList:data.data.PM10,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box5','ug/m³');
                        this.echartsFun({dataList:data.data.formaldehyde,timeList:data.data.updateTime},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box6','ppb');
                        this.echartsFun({dataList:data.data.VOC,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box7','lux');
                    })
                }
                else{
                    this.sensorLogList(this.sensorId,this.timeType2,0)
                }
            },
            /*传感器历史记录*/
            getSensorHistory(timeType,callback){
                base.ajax_post(
                    allUrl.roomLight.sensorHistory,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        deviceId:this.sensorId,
                        dateType:timeType,
                    },
                    {},
                    data=>{
                        console.log(data)
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )

            },
            echartsFun(data,type,color,className,unit){
                console.log(data,className)
                this.myChart2 = this.$echarts.init(document.getElementsByClassName(className)[0]);
                this.myChart2.setOption({
                    tooltip:{
                        trigger:'axis',
                        axisPointer:{
                            type : type=='bar'?'shadow':'line',
                            snap:true,
                        },
                        padding:0,
                        formatter: function (params) {
                            // console.log(params)
                            var tls = `<div class="history_echarts_tooltip"><p class="p1"><i style="background-color:${params[0].color}"></i><span class="span1">${params[0].value}</span><span class="span1">${unit}</span></p><p class="p2">${params[0].name}</p></div>`;
                           return tls;
                        },
                    },
                    grid:{
                        top:10,
                        left:40,
                        right:50,
                        bottom:40,
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: type=='bar'?true:false,
                        data: data.timeList,
                        axisTick:{
                            show:false,
                            alignWithLabel: true
                        },
                        axisLine:{
                            show:false
                        },
                        axisLabel:{
                            color:'rgba(163,175,187,1)',
                            fontStyle:'AlibabaPuHuiTiR',
                            fontSize:'1rem',
                        },
                    },
                    yAxis: {
                        type: 'value',
                        nameGap:6,
                        splitNumber:4,
                        axisTick:{
                            show:false,
                        },
                        axisLine:{
                            show:false
                        },
                        splitLine:{
                            lineStyle:{
                                color:'rgba(235,239,242,1)'
                            }
                        },
                        axisLabel:{
                            color:'rgba(163,175,187,1)',
                            fontStyle:'AlibabaPuHuiTiR',
                            fontSize:'1rem',
                        },
                    },
                    series: [{
                        data: data.dataList,
                        type: type,
                        smooth:true,
                        barWidth:type=='bar'?'50%':null,
                        symbol:type=='line'?'none':false,
                        lineStyle:{
                            color:color,
                        },
                        itemStyle:{
                            color:color,
                        },
                        markLine:{
                            data:type=='line'?[{type:'average',name:'平均值'}]:null,
                            lineStyle:{
                                color:'rgba(5,206,171,0.4)',
                                type:'dotted',
                            }
                        }
                    }]
                });
            },
            sensorLogList(devId,dateType,download){
                if(download == '1'){
                    this.loading.sensorDataList2_csv = true;
                }else{
                    this.loading.sensorDataList2 = true;
                }
                base.ajax_post(
                    allUrl.roomLight.sensorLogList,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,

                        deviceId:devId,
                        page:this.currentPage2,
                        count:this.pageSize2,
                        dateType:dateType,
                        // date:date,
                        download:download,
                    },
                    {},
                    data=>{
                        if(download == '1'){
                            this.loading.sensorDataList2_csv = false;
                            // var $eleBtn2 = $("#btn2");
                            var $eleForm = $("<form method='get'></form>");
                            $eleForm.attr("action",data.data.url);
                            $(document.body).append($eleForm);
                            //提交表单，实现下载
                            $eleForm.submit();
                        }else{
                            this.loading.sensorDataList2 = false;
                            this.sensorDataList2 = data.data.list;
                            this.total2 = Number(data.data.total);

                            let i = 1 + (this.currentPage2-1)*this.pageSize2;
                            for(let d of this.sensorDataList2){
                                d.webIndex = i;
                                i++;
                            }
                        }
                    },
                    this,()=>{
                        if(download == '1'){
                            this.loading.sensorDataList2_csv = false;
                        }else{
                            this.loading.sensorDataList2 = false;
                        }
                    }
                )
            },
            historyClose(){
                let this_ = this;
                this.historyShow = false;
                setTimeout(function(){
                    this_.historyShowbg = false;
                },400)
            },
            historySee(obj){
                this.sensorId = obj.id;
                this.historyShowbg = true;
                this.$nextTick(function(){
                    this.historyShow = true;
                    this.getSensorHistory(this.timeType2,data=>{
                        this.echartsFun({dataList:data.data.temperature,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box1','℃');
                        this.echartsFun({dataList:data.data.humidity,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box2','RH%');
                        this.echartsFun({dataList:data.data.CO2,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box3','ppm');
                        this.echartsFun({dataList:data.data.PM25,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box4','ug/m³');
                        this.echartsFun({dataList:data.data.PM10,timeList:data.data.updateTime},this.chartTypeStr,'rgba(10,130,207,1)','history_echarts_box5','ug/m³');
                        this.echartsFun({dataList:data.data.formaldehyde,timeList:data.data.updateTime},this.chartTypeStr,'rgba(5,206,171,1)','history_echarts_box6','ppb');
                        this.echartsFun({dataList:data.data.VOC,timeList:data.data.updateTime},this.chartTypeStr,'rgba(255,190,0,1)','history_echarts_box7','ppb');
                    })
                    // if(this.networHistoryType == '1'){

                    // }
                })
            },
            commandHide(val){
                this.$nextTick(function(){
                    if($('.'+val)&&$('.'+val+' >.select').offset()){
                        $('.'+val).animate({scrollTop: $('.'+val).scrollTop() + $('.'+val+' >.select').offset().top - $('.'+val).offset().top - 100})
                    }
                })
            },
            /*手动注册巡检指令*/
            dev_register(item){
                if(item.senser_dev_register_asy){
                    return
                }
                item.senser_dev_register_asy = true;
                base.ajax_postWs(
                    allUrl.roomLight.dev_register,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        sensorId:item.id,
                        clientId:this.clientid,
                    },
                    this
                )
                // base.ajax_post(
                //     allUrl.roomLight.dev_register,
                //     {
                //         username:this.username,
                //         client_key:this.client_key,
                //         token:this.token,
                //         sensorId:item.id,
                //     },
                //     {},
                //     data=>{
                //         this.getSensorList();
                //         this.$message({
                //           showClose: true,
                //           message: data.msg,
                //           type: 'success'
                //         });
                //     },
                //     this
                // )
            },
            /*编辑设备*/
            editFun(item){
                this.sensorTkTitle = this.$t('App.sensor.text1');
                this.sensorTkShowbg = true;
                for(let key in this.sensorForm){
                    this.sensorForm[key] = item[key];
                    console.log(key,item[key])
                }
                this.sensorId = item.id;
                if(!this.sensorForm.gatewayId){
                    this.sensorForm.gatewayId = '00000000'
                }
                this.getFloorNav(()=>{
                    for(let d of this.floorNav){
                        if(d.id == this.sensorForm.floorId){
                            this.sensorFormFloorName = d.name;
                        }
                    }
                })
                this.getRoomNav(()=>{
                    for(let d of this.roomNav){
                        console.log(d,this.sensorForm.roomId)
                        if(d.id == this.sensorForm.roomId){
                            this.sensorFormRoomName = d.number;
                        }
                    }
                });
                this.$nextTick(function(){
                    this.sensorTkShow = true;
                })
            },
            getGatewayList(callback){
                if(this.buildId){
                    this.loading.gatewayDataList = true;
                    base.ajax_post(
                        allUrl.gateway.getlist,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:1,
                            count:10,
                            type:'0',
                            // keywords:this.keywords,
                        },
                        {},
                        data=>{
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*添加编辑设备*/
            addSensorFun(){
                this.sensorTkTitle = this.$t('App.sensor.text2');
                this.sensorTkShowbg = true;
                for(let key in this.sensorForm){
                    this.sensorForm[key] = '';
                }
                this.getGatewayList(data=>{
                    if(data.data.list.length>0){
                        this.sensorForm.gatewayId = data.data.list[0].gatewayId;
                    }
                })
                this.sensorFormFloorName = '';
                this.sensorFormRoomName = '';
                
                this.sensorId = '0';
                this.getFloorNav(()=>{
                    if(this.floorNav.length > 0){
                        this.sensorForm.floorId = this.floorNav[0].id;
                        for(let d of this.floorNav){
                            if(d.id == this.sensorForm.floorId){
                                this.sensorFormFloorName = d.name;
                            }
                        }
                        this.getRoomNav(()=>{
                            if(this.roomNav.length > 0){
                                this.sensorForm.roomId = this.roomNav[0].id;
                                for(let d of this.roomNav){
                                    if(d.id == this.sensorForm.roomId){
                                        this.sensorFormRoomName = d.number;
                                    }
                                }
                            }
                        });
                    }
                })
                this.$nextTick(function(){
                    this.sensorTkShow = true;
                })
            },
            sensorTkClose(){
                let this_ = this;
                this.sensorTkShow = false;
                setTimeout(function(){
                    this_.sensorTkShowbg = false;
                },400)
            },
            commandModel(data){
                this.sensorForm.model = data.id;
            },
            commandFloor(data){
                this.sensorForm.floorId = data.id;
                this.sensorFormFloorName = data.name;
                this.getRoomNav(()=>{
                    this.sensorForm.roomId = '';
                    this.sensorFormRoomName = ''
                });
                this.sensorForm.roomId = '';
            },
            commandRoom(data){
                this.sensorForm.roomId = data.id;
                this.sensorFormRoomName = data.number;
            },
            postSaveSensor(){
                let this_ = this;
                base.ajax_post(
                    allUrl.roomLight.saveSensor,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        sensorId:this.sensorId,
                        type:'0',
                        ...this.sensorForm
                    },
                    {},
                    data=>{
                        this.getSensorList();
                        this.sensorTkShow = false;
                        setTimeout(function(){
                            this_.sensorTkShowbg = false;
                        },400)
                        this.$message({
                          showClose: true,
                          message: data.msg,
                          type: 'success'
                        });
                    },
                    this
                )
            },
            /*设备数据刷新*/
            postReData(arr){
                if(this.reDataIndex>0){
                    return
                }
                let lightId = '',isTrue = true;
                if(arr.length == 0){
                    isTrue = false;
                    this.$message({
                        message: this.$t('App.message.text11'),
                        type: 'warning'
                    });
                }else{
                    this.reDataIndex  = 0;
                    for(let id of arr){
                        if(lightId == ''){
                            lightId = id;
                        }else{
                            lightId += ','+id;
                        }
                        this.reDataIndex++;
                    }
                }
                if(isTrue){
                    base.ajax_postWs(
                        allUrl.roomLight.reData,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            id:lightId,
                            clientId:this.clientid,
                            type:2,
                        },
                        this
                    )
                }
            },
            /*删除设备*/
            postDelLight(obj,type){
                let sensorId = '',isTrue = true;
                if(type == 'batch'){
                    if(obj.length == 0){
                        isTrue = false;
                        this.$message({
                            message: this.$t('App.message.text11'),
                            type: 'warning'
                        });
                    }else{
                        for(let id of obj){
                            if(sensorId == ''){
                                sensorId = id;
                            }else{
                                sensorId += ','+id;
                            }
                        }
                    }
                }else{
                    sensorId = obj.id;
                }
                if(isTrue){
                    this.$confirm(
                        this.$t('App.message.text16'), this.$t('App.message.text17'), {
                            confirmButtonText: this.$t('App.message.text2'),
                            cancelButtonText: this.$t('App.message.text6'),
                            type: 'warning'
                        }
                    ).then(() => {
                        base.ajax_post(
                            allUrl.roomLight.delSensor,
                            {
                                username:this.username,
                                client_key:this.client_key,
                                token:this.token,
                                sensorId:sensorId,
                            },
                            {},
                            data=>{
                                this.$message({
                                  showClose: true,
                                  message: data.msg,
                                  type: 'success'
                                });
                                this.getSensorList();
                            },
                            this
                        )
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: this.$t('App.message.text18')
                        });          
                    });
                }
            },
            /*设备列表*/
            getSensorListKeyUp(e){
                if(e.key == 'Enter'){
                  this.getSensorList();
                }
            },
            getSensorList(callback){
                if(this.buildId){
                    this.loading.sensorDataList = true;
                    base.ajax_post(
                        allUrl.roomLight.sensorList,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            buildId:this.buildId,
                            // roomId:this.roomId,
                            page:this.currentPage,
                            count:this.pageSize,
                            type:'0',
                            keywords:this.keywords,
                        },
                        {},
                        data=>{
                            this.sensorDataList = data.data.list;
                            this.total = Number(data.data.total);
                            this.loading.sensorDataList = false;

                            this.sensorDataIdList = [];
                            this.checkList = [];
                            this.isIndeterminate = false;
                            this.checkAll = false;

                            let i = 1 + (this.currentPage-1)*this.pageSize;
                            for(let d of this.sensorDataList){
                                this.sensorDataIdList.push(d.id);
                                this.$set(d,'senser_dev_register_asy',false)
                                d.webIndex = i;
                                i++;
                            }
                            if(callback){
                                callback(data)
                            }
                            this.$nextTick(function(){
                                this.$refs.sensorDataList.doLayout();
                            })
                        },
                        this,()=>{
                            this.loading.sensorDataList = false;
                        }
                    )
                }
            },
            /*楼房下拉列表*/
            getBuildNav(callback){
                if(this.hotelId){
                    base.ajax_post(
                        allUrl.room.buildNav,
                        {
                            username:this.username,
                            client_key:this.client_key,
                            token:this.token,
                            hotelId:this.hotelId,
                        },
                        {},
                        data=>{
                            this.buildNav = data.data.list;
                            if(callback){
                                callback(data)
                            }
                        },
                        this
                    )
                }
            },
            /*楼层下拉列表*/
            getFloorNav(callback){
                base.ajax_post(
                    allUrl.room.floorNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                    },
                    {},
                    data=>{
                        this.floorNav = data.data.list;
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*楼间下拉列表*/
            getRoomNav(callback){
                base.ajax_post(
                    allUrl.room.roomNav,
                    {
                        username:this.username,
                        client_key:this.client_key,
                        token:this.token,
                        buildId:this.buildId,
                        floorId:this.sensorForm.floorId,
                    },
                    {},
                    data=>{
                        this.roomNav = data.data.list;
                        console.log(this.roomNav)
                        if(callback){
                            callback(data)
                        }
                    },
                    this
                )
            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.currentPage = 1;
                this.getSensorList();
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getSensorList();
                // console.log(val)
            },

            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.sensorLogList(this.sensorId,this.timeType2,0)
            },
            handleCurrentChange2(val) {
                this.currentPage2 = val;
                this.sensorLogList(this.sensorId,this.timeType2,0)
                // console.log(val)
            },

            handleCheckAllChange(val) {
                this.checkList = val ? this.sensorDataIdList : [];
                this.isIndeterminate = false;
            },
            handleCheckedCitiesChange(value){
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.sensorDataIdList.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.sensorDataIdList.length;
            },
        },
        watch:{
            hotelId:function(){
                this.getBuildNav(()=>{
                    if(this.buildNav.length > 0){
                        this.buildId = this.buildNav[0].id;
                        this.getFloorNav(data=>{
                            this.tableFloorNav = data.data.list
                        })
                    }else{
                        this.buildId = '';
                    }
                    this.currentPage = 1;
                    this.getSensorList();
                });
            },
            buildId:function () {
                this.currentPage = 1;
                this.getSensorList();
            },
            updateRemRatio:function(){
                clearTimeout(this.updateRemRatioShakeProof)
                this.updateRemRatioShakeProof = setTimeout(()=>{
                    this.sensorArr = [
                        {prop:'floor',label:this.$t('App.room.text29'),minWidth:5*this.remRatio,unit:''},
                        {prop:'roomNumber',label:this.$t('App.room.text30'),minWidth:5*this.remRatio,unit:''},
                        {prop:'temperature',label:this.$t('App.dashboard.text11'),minWidth:7.8*this.remRatio,unit:'℃'},
                        {prop:'humidity',label:this.$t('App.dashboard.text12'),minWidth:5.8*this.remRatio,unit:'%RH'},
                        {prop:'co2',label:'CO₂',minWidth:5*this.remRatio,unit:'ppm'},
                        {prop:'pm25',label:'PM2.5',minWidth:5*this.remRatio,unit:'ug/m³'},
                        {prop:'pm10',label:'PM10',minWidth:5*this.remRatio,unit:'ug/m³',type:1},
                        {prop:'voc',label:'TVOC',minWidth:5*this.remRatio,unit:'ppb'},
                        {prop:'formaldehyde',label:this.$t('App.dashboard.text13'),minWidth:5*this.remRatio,unit:'ppb'},
                        {prop:'online',label:this.$t('App.sensor.text9'),minWidth:7.5*this.remRatio,type:1,unit:''},
                        {prop:'alarmStatus',label:this.$t('App.lights.text31'),minWidth:10*this.remRatio,type:1,unit:''},
                        {prop:'updateTime',label:this.$t('App.lights.text32'),width:10.5*this.remRatio,unit:''},
                    ];
                    this.$nextTick(function(){
                        this.$refs.sensorDataList.doLayout();
                    })
                },1000)
            }
        }
    }
</script>

<style type="text/css" lang="less">
    .sensor_main{
        width: 100%;
        height: 100%;
        // height: 105rem;
        min-height: 50rem;
        // min-width: 120rem;
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        display: flex;
        background: #F6F8FA;
        &.cn{
            .sensor_right{
                .sensor_right_top .right_top_l > .el-input .el-icon-search{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
                .sensor_right_main .main_cont{
                    .el-table .brightness .btn_img .bg{
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                    .el-table .btn:hover i{
                        color: #8266C7;
                    }
                    .pagination_box .el-pager li{
                        &:hover{
                            color: #513C93;
                            background:rgba(130,102,199,0.1);
                        }
                        &.active{
                            color: #FFFFFF;
                            background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                        }
                    }
                }
            }
            .history_warp .history_box{
                .table_box .pagination_box .el-pager li{
                    &:hover{
                        color: #513C93;
                        background:rgba(130,102,199,0.1);
                    }
                    &.active{
                        color: #FFFFFF;
                        background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                    }
                }
                .table_top_box .box1 .btn.select{
                    background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
                }
            }
            .sensor_wrap .sensor_box .btn_box .btn{
                background:linear-gradient(89deg,rgba(124,93,156,1) 0%,rgba(62,50,139,1) 100%);
            }
        }
        .sensor_left{
            width: 11.67rem;
            height: 100%;
            min-width: 130px;
        }
        .sensor_right{
            position: relative;
            padding: 1.92rem 1.5rem 0;
            width: calc(100% - 11.67rem);
            height: calc(100%);
            .sensor_right_top{
                display: flex;
                justify-content: space-between;
                .right_top_l{
                    .el-input__inner{
                        height: 2.5rem;line-height: 2.5rem;
                        border-radius: 1.25rem;
                        font-family: AlibabaPuHuiTiR;
                        font-size: 1rem;
                        color: #333333;
                        border-color: #F0F0F0;
                    }
                    .el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-select{
                        width: 11.42rem;
                    }
                    >.el-input{
                        margin-left: 1rem;
                        width: 20rem;
                        .el-icon-search{
                            display: inline-block;
                            top: 0;bottom: 0;
                            right: 0;
                            width: 4rem;
                            background: #05CFAB;
                            border-radius: 1.25rem;
                            cursor: pointer;
                            color: #FFFFFF;
                        }
                        .el-input__suffix{
                            right: 0;
                        }
                    }
                }
            }
            .sensor_right_main{
                height: calc(100% - 6.5rem);
                margin-top: 1rem;
                position: relative;
                background: #FFFFFF;
                border: 1px solid #F0F0F0;
                border-radius: 0.4rem;
                .main_top{
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 1.67rem 0 1rem;
                    .main_top_l{
                        .div1{
                            margin-top: 1.5rem;
                            font-family: AlibabaPuHuiTiB;
                            font-size: 1.5rem;
                            color: #333333;
                        }
                        .div2{
                            margin-top: 1.33rem;
                            display: flex;
                            align-items: center;
                            .btn{
                                margin-left: 1.29rem;
                                display: flex;align-items: center;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                cursor: pointer;
                                i{
                                    font-size:0.8rem;
                                    color: #C6CDD5;
                                }
                                span{
                                    margin-left: 0.5rem;
                                }
                            }
                        }
                    }
                    .main_top_r{
                        margin-top: 2.33rem;
                        display: flex;
                        .btn{
                            margin-left: 1rem;
                            height: 2.5rem;line-height: 2.5rem;
                            padding: 0 1.25rem;
                            background: #FFFFFF;
                            border: 1px solid #F0F0F0;
                            border-radius: 1.25rem;
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            img{
                                margin-right: 0.5rem;
                                height: 1rem;
                            }
                        }
                    }
                }
                .main_cont{
                    height: calc(100% - 11rem);
                    margin-top: 0.75rem;
                    .el-checkbox-group{
                        height: 100%;
                    }
                    .el-table{
                        .el-checkbox{
                            margin-left: 1rem;
                            .el-checkbox__label{
                                padding-left: 0.5rem;
                            }
                        }
                        .btn{
                            padding: 0.5rem;
                            cursor: pointer;
                            &+.btn{
                                margin-left: 0.2rem;
                            }
                            i{
                                color: #A3AFBB;
                                font-size:0.8rem;
                            }
                            &:hover{
                                i{
                                    color: #05CFAB;
                                }
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                                padding: 0 0.5rem;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .alarmStatus{
                            .text_1{
                                cursor: pointer;
                                color: rgba(255,12,77,1);
                                i{
                                    margin-left: 0.2rem;
                                    font-size: 1rem;
                                }
                            }
                        }
                        .online{
                            .iconfont{
                                font-size: 1.2rem;
                            }
                        }
                    }
                    .pagination_box{
                        .el-pagination{
                            float: right;
                            margin-top: 0.5rem;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .sensor_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .sensor_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .sensor_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.sensor_tk_show{
                    right: 0rem; 
                }
                .sensor_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .form{
                    margin-top: 1.96rem;
                    .form_item{
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        height: 3.33rem;line-height: 3.33rem;
                        margin: 0 2.5rem 1.67rem;
                        padding: 0 1.67rem 0 1.08rem;
                        background: #F6F8F7;
                        .laber{
                            font-family: PingFang-SC-Medium;
                            font-size: 1rem;
                            color: #333333;
                        }
                        .el-dropdown{
                            cursor: pointer;
                            i{
                                margin-left: 1.67rem;
                            }
                        }
                        .el-input{
                            width: calc(100% - 8rem);
                            .el-input__inner{
                                font-family: PingFang-SC-Medium;
                                font-size: 1rem;
                                color: #657085;
                                text-align: right;
                                background: initial;
                                border: none;
                            }
                        }
                    }
                }
                .btn_box{
                    position: absolute;
                    width: 100%;
                    bottom: 1.67rem;
                    .btn{
                        width: 11.67rem;height: 2.67rem;line-height: 2.67rem;
                        margin: 0 auto;
                        background: #05CFAB;
                        border-radius: 0.2rem;
                        text-align:center;
                        cursor: pointer;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #FFFFFF;
                    }
                }
            }
        }
        .history_warp{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .history_warp_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            .history_box{
                position: absolute;
                width: 80.42rem;height: 100%;min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -80.42rem;
                transition: all 0.5s;
                &.history_show{
                   right: 0rem; 
                }
                .history_top{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .filter_box{
                    height: 4.3rem;
                    padding: 1.63rem 0 0rem;
                    padding-left: 2.5rem;
                    .el-select{
                        margin-right: 0.83rem
                    }
                    .el-input__inner,.el-input__icon{
                        height: 2.5rem;line-height: 2.5rem;
                    }
                    .el-input__inner{
                        border-radius: 1.25rem;
                    }
                }
                .table_top_box{
                    position: relative;
                    .download_btn{
                        position: absolute;
                        right: 3rem;top: 0.12rem;

                        height: 2.5rem;line-height: 2.5rem;
                        padding: 0 1.25rem;
                        background: #FFFFFF;
                        border: 1px solid #F0F0F0;
                        border-radius: 1.25rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1rem;
                        color: #333333;
                        cursor: pointer;
                    }
                    .box1{
                        display: flex;
                        width: 18.5rem;height: 2.75rem;line-height: 2.75rem;
                        background-color:rgba(246, 248, 250, 1);
                        border-radius:1.38rem;
                        margin: 0.8rem auto 0.8rem;
                        .btn{
                            flex: 1;
                            text-align: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiR;
                            color:rgba(51,51,51,1);
                            cursor: pointer;
                            &.select{
                                background-color:rgba(5, 207, 171, 1);
                                color:rgba(255,255,255,1);
                                border-radius:1.67rem;
                            }
                        }
                    }
                }
                .echarts_warp{
                    height:calc(100%  - 13rem);
                }
                .echarts_box{
                    height: calc(17rem);
                    margin: 0 1.8rem 1.67rem 2.5rem;
                    background: #F6F8F7;
                    border-radius: 5px;
                    .echarts_top{
                        padding-left: 1.67rem;
                        line-height: 2.5rem;
                        font-family: AlibabaPuHuiTiB;
                        font-size: 1rem;
                        color: #333333;
                    }
                    .history_echarts_tooltip{
                        background-color:#fff;
                        padding: 0.3rem 1rem 0.67rem 0;
                        .p1{
                            display: flex;
                            align-items: center;
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(51,51,51,1);
                            i{
                                margin-left: 0.92rem;
                                margin-right: 0.5rem;
                                display: inline-block;
                                width: 0.25rem;height: 0.25rem;
                                border-radius: 50%;
                            }
                            .span1{
                                margin-right: 0.3rem;
                            }
                        }
                        .p2{
                            font-size:1rem;
                            font-family:AlibabaPuHuiTiM;
                            color:rgba(163,175,187,1);
                            padding-left: 1.75rem;
                        }

                    }
                    .history_echarts_box1{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box2{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box3{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box4{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box5{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box6{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                    .history_echarts_box7{
                        width: 100%;height: calc(100% - 2.5rem);
                    }
                }
                .table_box{
                    height: calc(100% - 17rem);
                    .el-table{
                        .el-loading-spinner{
                            margin-top: -0.75rem;
                            .circular{
                                width: 1.5rem;height: 1.5rem;
                            }
                        }
                        th{
                            font-weight:initial;
                            height: 3rem;
                            border-top: 1px solid #F0F0F0;
                            border-bottom: 1px solid #F0F0F0;
                            padding: 0;
                            background: #F6F8FA;
                            &>.cell{
                                height: 3rem;line-height: 3rem;
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #333333;
                            }
                            div{
                                height: 3rem;line-height: 3rem;
                            }
                        }
                        td{
                            padding: 0;
                            height: 3rem;
                            &>.cell,.el-checkbox__label{
                                font-family: AlibabaPuHuiTiR;
                                font-size: 1rem;
                                color: #657085;
                            }
                        }
                        .brightness{
                            display: flex;
                            align-items: center;
                            justify-content:flex-end;
                        }
                        .color{
                            display: flex;
                            align-items: center;
                            justify-content:center;
                        }
                        .alarmStatus{
                            .text_1{
                                color: rgba(255,12,77,1);
                                img{
                                    margin-left: 0.2rem;
                                }
                            }   
                        }
                    }
                    .pagination_box{
                        margin-top: 0.5rem;
                        .el-pagination{
                            float: right;
                            // margin-top: 0.5rem;
                            padding:0;
                        }
                        height: 2.5rem;line-height: 2.5rem;
                        .btn-prev .el-icon{
                            font-size:1rem;
                            color: #666666;
                            font-family: PingFang-SC-Medium;
                        }
                        button{
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                        }
                        .el-pager li{
                            margin-left: 0.83rem;
                            width: 2.33rem;height: 2.33rem;line-height: 2.33rem;
                            padding: 0;
                            background: #F6F8FA;
                            border-radius: 0.2rem;
                            &:hover{
                                color: rgba(5,207,171,1);
                                background-color: rgba(5,207,171,0.1);
                            }
                        }
                        .btn-next{
                            margin-left: 0.83rem;
                        }
                        .el-pager li.active{
                            background: #05CFAB;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .gatewayUpdate_wrap{
            position: fixed;
            top: 0;left: 0;right: 0;bottom: 0;
            z-index: 2000;
            .gatewayUpdate_wrap_bg{
                position: absolute;
                top: 0;left: 0;width: 100%;height: 100%;min-height: 50rem;
                background-color:rgba(57,57,57,0.3);
            }
            // overflow: hidden;
            .gatewayUpdate_box{
                position: absolute;
                width: 36rem;height: 100%;
                min-height: 50rem;
                background: #FFFFFF;
                box-shadow: 0 0 8px 0 rgba(0,0,0,0.12);
                right: -36rem;
                transition: all 0.5s;
                &.gateway_tk_show{
                    right: 0rem; 
                }
                .gatewayUpdate_title{
                    height: 4.1rem;line-height: 4.1rem;
                    display: flex;
                    justify-content: space-between;
                    padding: 0 2.5rem 0 2.5rem;
                    border: 0.1rem solid rgba(240,240,240,1);
                    .span1{
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #333333;
                    }
                    .span2{
                        padding: 0 0.5rem;
                        font-family: PingFang-SC-Medium;
                        font-size: 1.17rem;
                        color: #999999;
                        cursor: pointer;
                    }
                }
                .box1{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width:calc(100% - 2.5rem);
                    height:5.08rem;
                    margin:2.5rem auto 0;
                    padding: 0 1.5rem;
                    background:rgba(246,248,247,1);
                    img{
                        height: 3rem;
                    }
                    span{
                        font-size:1.67rem;
                        font-family:AlibabaPuHuiTiH;
                        color:rgba(51,51,51,1);
                    }
                }
                .p1{
                    width:calc(100% - 2.5rem);
                    margin:0.75rem auto 0;
                    height:1.42rem;
                    line-height:1.42rem;
                    font-size:1rem;
                    font-family:AlibabaPuHuiTiR;
                    color:rgba(101,112,133,1);
                }
                .btn_box{
                    width:calc(100% - 2.5rem);
                    margin:2rem auto 0;
                    height:2.67rem;
                    background:rgba(5, 207, 171, 0.1);
                    .btn{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        background:rgba(5,207,171,1);
                        border-radius:0.17rem;

                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }
                    .el-progress{
                        .el-loading-mask{
                            background: rgba(255,255,255,0.1);
                        }
                        .el-progress-bar__outer{
                            height: 2.67rem;
                            background-color:initial;
                            border-radius: 0;
                            .el-progress-bar__inner{
                                border-radius: 0;
                                background-color:rgba(5, 207, 171, 1);
                            }
                        }
                    }
                    .text{
                        width: 100%;height: 100%;line-height: 2.67rem;
                        text-align: center;
                        border-radius:0.17rem;
                        font-size:1rem;
                        font-family:PingFang-SC-Medium,PingFang-SC;
                        font-weight:500;
                        color:rgba(255,255,255,1);
                        &.span1{
                            background-color: rgba(255, 12, 77, 1);
                            cursor:pointer;
                        }
                        &.span2{
                            background-color: rgba(165, 201, 195, 1);
                        }
                    }
                }
            }
        }
    }
</style>